import {
  InstagramLogo,
  FacebookLogo,
  YoutubeLogo,
  TiktokLogo,
  TwitterLogo,
  LinkedinLogo,
  WhatsappLogo,
  TelegramLogo,
  PinterestLogo,
  EnvelopeSimple,
  Globe,
} from "@phosphor-icons/react";
import { useSiteContent } from "@/contexts/SiteContentContext";

const ICONS = {
  instagram: InstagramLogo,
  facebook: FacebookLogo,
  youtube: YoutubeLogo,
  tiktok: TiktokLogo,
  twitter: TwitterLogo,
  x: TwitterLogo,
  linkedin: LinkedinLogo,
  whatsapp: WhatsappLogo,
  telegram: TelegramLogo,
  pinterest: PinterestLogo,
  email: EnvelopeSimple,
  web: Globe,
};

function iconFor(platform) {
  const key = (platform || "").toLowerCase();
  return ICONS[key] || Globe;
}

function labelFor(platform) {
  const map = {
    instagram: "Instagram",
    facebook: "Facebook",
    youtube: "YouTube",
    tiktok: "TikTok",
    twitter: "X / Twitter",
    x: "X / Twitter",
    linkedin: "LinkedIn",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    pinterest: "Pinterest",
    email: "Email",
    web: "Website",
  };
  return map[(platform || "").toLowerCase()] || platform;
}

export default function BigSocialBar() {
  const content = useSiteContent();
  const bar = content?.social_bar;
  if (!bar?.enabled) return null;
  const items = (bar.items || []).filter((i) => i?.url && i.url.trim() && i.url.trim() !== "#");
  if (items.length === 0) return null;

  return (
    <section data-testid="big-social-bar" className="border-t border-white/10 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <p className="text-overline mb-4">{bar.heading || "Social"}</p>
          <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl leading-[0.95]">
            {bar.subtitle || "Παντού. Πάντα."}
          </h2>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
          {items.map((item, i) => {
            const Icon = iconFor(item.platform);
            const isEmail = item.platform === "email";
            const href = isEmail && !item.url.startsWith("mailto:") ? `mailto:${item.url}` : item.url;
            return (
              <a
                key={i}
                href={href}
                target={isEmail ? undefined : "_blank"}
                rel="noreferrer"
                data-testid={`social-big-${item.platform}`}
                className="group flex flex-col items-center justify-center gap-3 border border-white/10 bg-[#141414] p-5 md:p-8 aspect-square hover:border-[#E50000] hover:bg-[#0F0F0F] transition-all duration-300"
                aria-label={labelFor(item.platform)}
              >
                <Icon
                  size={36}
                  weight="duotone"
                  className="text-white/70 group-hover:text-[#E50000] transition-colors md:!size-12"
                />
                <span className="text-[10px] md:text-xs font-bold uppercase tracking-[0.18em] text-white/50 group-hover:text-white transition-colors">
                  {labelFor(item.platform)}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
